export const wyrm_list_3 = [
  {
    type: 0,
    id: 400006,
    abilities: [ 
      { exclusive: '', effect: 'brk_pns', value: 20, maxValue: 30}
    ]
  }, {
    type: 0,
    id: 400007,
    abilities: [ 
      { exclusive: '', effect: 'rcv_ptn', value: 8, maxValue: 20}
    ]
  }, {
    type: 0,
    id: 400008,
    abilities: [ 
      { exclusive: '', effect: 'skl_prp', value: 20, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400009,
    abilities: [ 
      { exclusive: '', effect: 'bf_tm', value: 20, maxValue: 30}
    ]
  }, {
    type: 0,
    id: 400010,
    abilities: [ 
      { exclusive: '', effect: 'frc_stk', value: 30, maxValue: 50}
    ]
  }, {
    type: 0,
    id: 400011,
    abilities: [ 
      { exclusive: '', effect: 'crt_dmg', value: 13, maxValue: 25}
    ]
  }, {
    type: 0,
    id: 400012,
    abilities: [ 
      { exclusive: '', effect: 'crt_rt', value: 5, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400013,
    abilities: [ 
      { exclusive: '', effect: 'bln_rs', value: 25, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400014,
    abilities: [ 
      { exclusive: '', effect: 'prl_rs', value: 25, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400015,
    abilities: [ 
      { exclusive: '', effect: 'bg_rs', value: 25, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400016,
    abilities: [ 
      { exclusive: '', effect: 'shs_prp', value: 10, maxValue: 10}
    ]
  }, {
    type: 0,
    id: 400017,
    abilities: [ 
      { exclusive: '', effect: 'skl_hst', value: 5, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400018,
    abilities: [ 
      { exclusive: '', effect: 'lst_dfn', value: 50, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400019,
    abilities: [ 
      { exclusive: '', effect: 'rcv_ptn', value: 8, maxValue: 20}
    ]
  }, {
    type: 0,
    id: 400020,
    abilities: [ 
      { exclusive: '', effect: 'brn_rs', value: 25, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400021,
    abilities: [ 
      { exclusive: '', effect: 'crt_dmg', value: 15, maxValue: 25}
    ]
  }, {
    type: 0,
    id: 400022,
    abilities: [ 
      { exclusive: '', effect: 'gg_inh', value: 25, maxValue: 50}
    ]
  }, {
    type: 0,
    id: 400023,
    abilities: [ 
      { exclusive: '', effect: 'slyr_str', value: 4, maxValue: 6}
    ]
  }, {
    type: 0,
    id: 400024,
    abilities: [ 
      { exclusive: '', effect: 'skl_dmg', value: 20, maxValue: 40}
    ]
  }, {
    type: 0,
    id: 400025,
    abilities: [ 
      { exclusive: '', effect: 'hfl_str', value: 10, maxValue: 20}
    ]
  }, {
    type: 0,
    id: 400026,
    abilities: [ 
      { exclusive: '', effect: 'stn_rs', value: 25, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400027,
    abilities: [ 
      { exclusive: '', effect: 'slyr_str', value: 4, maxValue: 6}
    ]
  }, {
    type: 0,
    id: 400028,
    abilities: [ 
      { exclusive: '', effect: 'psn_rs', value: 25, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400029,
    abilities: [ 
      { exclusive: '', effect: 'skl_prp', value: 20, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400031,
    abilities: [ 
      { exclusive: '', effect: 'frz_rs', value: 25, maxValue: 100}
    ]
  }, {
    type: 1,
    id: 400032,
    abilities: [ 
      { exclusive: '', effect: 'crs_rs', value: 25, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400101,
    abilities: [ 
      { exclusive: '', effect: 'slp_rs', value: 25, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400106,
    abilities: [ 
      { exclusive: '', effect: 'hfl_dfn', value: 20, maxValue: 20}
    ]
  }, {
    type: 0,
    id: 400113,
    abilities: [ 
      { exclusive: 'light', effect: 'skl_hst', value: 6, maxValue: 15}
    ]
  }, {
    type: 1,
    id: 400117,
    abilities: [ 
      { exclusive: '', effect: 'rcv_ptn', value: 8, maxValue: 20}
    ]
  }, {
    type: 0,
    id: 400130,
    abilities: [ 
      { exclusive: '', effect: 'skl_prp', value: 20, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400137,
    abilities: [ 
      { exclusive: 'wind', effect: 'brk_pns', value: 25, maxValue: 30}
    ]
  }, {
    type: 0,
    id: 400141,
    abilities: [ 
      { exclusive: '', effect: 'skl_prp', value: 20, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400151,
    abilities: [ 
      { exclusive: '', effect: 'bg_rs', value: 25, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400156,
    abilities: [ 
      { exclusive: 'shadow', effect: 'skl_hst', value: 6, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400175,
    abilities: [ 
      { exclusive: 'water', effect: 'skl_hst', value: 6, maxValue: 15}
    ]
  }, {
    type: 3,
    id: 400279,
    abilities: [ 
      { exclusive: '', effect: 'drg_tm', value: 6, maxValue: 20}
    ]
  }
].reverse()